import { Injectable } from '@angular/core';
import { PersonaPadlockError } from '@technologyfromsage/persona-padlock';
import * as URI from 'urijs';

import { AuthorizationFailedException } from '®shared/auth';
import { ErrorReportingService } from '®shared/reporting/error-reporting.service';

@Injectable()
export class AuthErrorService {
  constructor(private errorReportingService: ErrorReportingService) {}

  public buildUserAuthErrorUrl(error: unknown): string {
    const getErrorDetails = () => {
      if (error instanceof PersonaPadlockError) {
        return {
          title: $localize`:@@authErrorService-loginErrorTitle:Login error`,
          message: $localize`:@@authErrorService-loginErrorMessage:An error occurred during login`,
          code: '401',
        };
      }
      if (error instanceof AuthorizationFailedException) {
        return {
          title: $localize`:@@authErrorService-authorizationErrorTitle:Authorization error`,
          message: $localize`:@@authErrorService-authorizationErrorMessage:You do not have the required permissions to access this page`,
          code: '403',
        };
      }
      return {
        title: $localize`:@@authErrorService-unknownErrorTitle:Unknown error`,
        message: $localize`:@@authErrorService-unknownErrorMessage:An error occurred during login`,
        code: '500',
      };
    };

    const { title, message, code } = getErrorDetails();
    if (code === '500') {
      this.errorReportingService.reportToInstana(error);
    }
    const errorUri = new URI('/error.html');
    errorUri.addQuery('title', title);
    errorUri.addQuery('detail', message);
    errorUri.addQuery('code', code);

    return errorUri.toString();
  }
}
